import React, { useState, useEffect } from 'react';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later
      setDeferredPrompt(e);
      // Check if previously dismissed (7-day timeout)
      checkDismissalStatus();
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Check on mount if we should show the prompt
    checkDismissalStatus();

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const checkDismissalStatus = () => {
    const dismissalTime = localStorage.getItem('installPromptDismissed');
    if (dismissalTime) {
      const dismissedAt = parseInt(dismissalTime, 10);
      const now = Date.now();
      const sevenDays = 7 * 24 * 60 * 60 * 1000;

      if (now - dismissedAt < sevenDays) {
        setDismissed(true);
        return;
      } else {
        // Dismiss timeout expired, clear it
        localStorage.removeItem('installPromptDismissed');
        setDismissed(false);
      }
    }

    // Only show if we have a deferred prompt and app is not already installed
    if (deferredPrompt && !dismissed) {
      setShowPrompt(true);
    }
  };

  const handleInstall = async () => {
    if (deferredPrompt) {
      // Show the install prompt
      deferredPrompt.prompt();
      // Wait for user to respond
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setShowPrompt(false);
        localStorage.removeItem('installPromptDismissed');
      } else {
        // User dismissed, don't show for 7 days
        dismissPrompt();
      }
      // Clear the deferred prompt
      setDeferredPrompt(null);
    }
  };

  const dismissPrompt = () => {
    localStorage.setItem('installPromptDismissed', Date.now().toString());
    setShowPrompt(false);
    setDismissed(true);
  };

  if (!showPrompt || dismissed) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#060a14',
        borderTop: '1px solid #1e293b',
        padding: '12px 16px',
        zIndex: 1000,
        boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.3)',
        fontFamily: '"DM Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      }}
    >
      <span
        style={{
          color: '#e2e8f0',
          fontSize: '14px',
          fontWeight: '500',
          flex: 1,
        }}
      >
        Install ShipFast for quick access
      </span>
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <button
          onClick={handleInstall}
          style={{
            backgroundColor: '#d4a053',
            color: '#060a14',
            border: 'none',
            padding: '8px 16px',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            whiteSpace: 'nowrap',
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = '#c89042')}
          onMouseOut={(e) => (e.target.style.backgroundColor = '#d4a053')}
        >
          Install
        </button>
        <button
          onClick={dismissPrompt}
          style={{
            backgroundColor: 'transparent',
            color: '#64748b',
            border: 'none',
            padding: '4px 8px',
            cursor: 'pointer',
            fontSize: '18px',
            transition: 'color 0.2s',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onMouseOver={(e) => (e.target.style.color = '#cbd5e1')}
          onMouseOut={(e) => (e.target.style.color = '#64748b')}
          aria-label="Dismiss install prompt"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default InstallPrompt;
